import React from 'react';

import CustomTooltip from '../CustomTooltip/CustomTooltip';

import './StyledLinearProgressNE.scss';

interface StyledLinearProgressProps {
  value: number;
  filledTooltip?: string | number;
  unfilledTooltip?: string | number;
  showTooltipPercentage?: boolean;
}

const StyledLinearProgress = ({
  value,
  filledTooltip,
  unfilledTooltip,
  showTooltipPercentage = true
}: StyledLinearProgressProps) => {
  const filledPercentage = value + '%';
  const unfilledPercentage = 100 - value + '%';

  const tooltip = (text: string | number, percentage: string, color: 'primary' | 'secondary') => {
    const squareClasses = ['square', color].join(' ');
    return (
      <div className="tooltip-content">
        <div className={squareClasses}></div>
        <div className="tooltip-text">
          {showTooltipPercentage && percentage} {text}
        </div>
      </div>
    );
  };

  return (
    <div className="progress-bar flex flex-row items-center" data-experience="new">
      {filledTooltip ? (
        <CustomTooltip placement="top" tooltipTitle={tooltip(filledTooltip, filledPercentage, 'primary')}>
          <div className="filled" style={{ width: filledPercentage }} data-testid="progressBar-filled"></div>
        </CustomTooltip>
      ) : (
        <div className="filled" style={{ width: filledPercentage }} data-testid="progressBar-filled"></div>
      )}
      {unfilledTooltip ? (
        <CustomTooltip placement="top" tooltipTitle={tooltip(unfilledTooltip, unfilledPercentage, 'secondary')}>
          <div className="unfilled" style={{ width: unfilledPercentage }} data-testid="progressBar-unfilled"></div>
        </CustomTooltip>
      ) : (
        <div className="unfilled" style={{ width: unfilledPercentage }} data-testid="progressBar-unfilled"></div>
      )}
    </div>
  );
};

export default StyledLinearProgress;
